import request from '@/utils/request'
import qs from 'qs'
//========= 检测
// 获取设备类型
export const querySysData = (postData) => {
  return request({
    url: '/check/querySysData?dataType=equipment_type',
    method: 'post',
    data: postData
  })
}
// 查看检测设备总台数
export const getDeviceCounts = (postData) => {
  return request({
    url: '/check/getDeviceCounts',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看复检合格
export const recheckQualified = (postData) => {
  return request({
    url: '/check/recheckQualified',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看一次合格
export const onceQualified = (postData) => {
  return request({
    url: '/check/onceQualified',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看平均不合格项
export const averageNonconformities = (postData) => {
  return request({
    url: '/check/averageNonconformities',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看检测设备合格项
export const getNumberQualified = (postData) => {
  return request({
    url: '/check/getNumberQualified',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看区域
export const queryArea = (postData) => {
  return request({
    url: '/check/report/queryArea',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看月度设备数量
export const getNumberMonth = (postData) => {
  return request({
    url: '/check/getNumberMonth',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 不同区域设备总数，不同区域的合格率
export const getDeviceTotalPassRate = (postData) => {
  return request({
    url: '/check/getDeviceTotalPassRate',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 不同厂家/不同安装单位 设备出现钢结构缺陷数量
export const getNumberOfSteelDefects = (postData) => {
  return request({
    url: '/check/getNumberOfSteelDefects',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 所有设备得隐患总数，不同设备得隐患数，和比值
export const getTotalNumberOfHiddenDangers = (postData) => {
  return request({
    url: '/check/getTotalNumberOfHiddenDangers',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看检测不同设备的总数
export const getDifferentDeviceCounts = (postData) => {
  return request({
    url: '/check/getDifferentDeviceCounts',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 整改中出现频率最高的前10项
export const getRectificationTop = (postData) => {
  return request({
    url: '/check/getRectificationTop',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看所有保证项目隐患总数和一般项目隐患总数
export const getDeviceCountByQualifiedType = (postData) => {
  return request({
    url: '/check/getDeviceCountByQualifiedType',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 不同设备类型得保证数ensure或一般数generally
export const getEnsureOrGenerally = (postData) => {
  return request({
    url: '/check/getEnsureOrGenerally',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据不同维度查看检测报告合格率
export const queryTestReport = (postData) => {
  return request({
    url: '/check/report/queryTestReport',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看检测报告合格数量
export const queryTestReportCount = (postData) => {
  return request({
    url: '/check/report/queryTestReportCount',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: qs.stringify(postData)
  })
}
// 相同类型的不同年限的产品合格率
export const queryTestReportByYear = (postData) => {
  return request({
    url: '/check/report/queryTestReportByYear',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据区域查看检测报告合格率
export const queryTestReportByArea = (postData) => {
  return request({
    url: '/check/report/queryTestReportByArea',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//(info)根据不同维度查看检测报告合格率 详情
export const queryTestReportInfo = (postData) => {
  return request({
    url: '/check/report/queryTestReportInfo',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 不同设备得隐患数，和比值
export const getDeviceRatio = (postData) => {
  return request({
    url: '/check/getDeviceRatio',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
export const deviceTypeGeneralAndGuarantee = (postData) => {
  return request({
    url: '/check/deviceTypeGeneralAndGuarantee',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//(info)根据区域查看检测报告合格率 详情
export const queryTestReportByAreaInfo = (postData) => {
  return request({
    url: '/check/report/queryTestReportByAreaInfo',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//(info)不同厂家/不同安装单位 设备出现钢结构缺陷数量占比 详情
export const getNumberOfSteelDefectsTop = (postData) => {
  return request({
    url: '/check/getNumberOfSteelDefectsTop',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//（info)整改中出现频率最高的详情
export const getRectificationTopDetails = (postData) => {
  return request({
    url: '/check/getRectificationTopDetails',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//查看检测设备总台数
export const numberOfDevices = (postData) => {
  return request({
    url: '/check/numberOfDevices',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//查看隐患项目总数
export const getDeviceHiddenDangerCount = (postData) => {
  return request({
    url: '/check/getDeviceHiddenDangerCount',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//查看安全分值
export const securityScore = (postData) => {
  return request({
    url: '/check/securityScore',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 台账
export const checkLedger = (postData) => {
  return request({
    url: '/account/checkLedger',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//台账下载
export const checkLedgerExport = (postData) => {
  return request({
    url: '/account/checkLedgerExport',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded;'
    },
    data: qs.stringify(postData),
    responseType: 'blob'
  })
}
//台账展示的列
export const querySelfDisplaycol = (postData) => {
  return request({
    url: '/account/querySelfDisplaycol',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//修改展示的列
export const updateSelfDisplaycol = (postData) => {
  return request({
    url: '/account/updateSelfDisplaycol',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//塔机吨米统计
export const tsqzjDm = (postData) => {
  return request({
    url: '/check/tsqzjDm',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
